<template>
  <span :style="{color}">
    <span>{{ sign }}{{ absolute | currencyRounded(valueSuffix, 2) }}</span>
    <span v-if="percent"> ( {{ sign }}{{ percent | currencyRounded('%', 2) }} )</span>
  </span>
</template>

<script>
//TODO this should replace percentage change someday
export default {
  name: "FinValueChange",
  props: {
    absolute: {
      type: Number
    },
    percent: {
      type: Number
    },
    valueSuffix: {
      type: String
    },
    noAutoColor: {
      type: Boolean
    },
  },
  computed: {
    isPositive() {
      return this.absolute > 0
    },
    sign() {
      return this.isPositive ? '+' : ''
    },
    color() {
      if (this.noAutoColor) {
        return 'unset'
      }
      return this.isPositive ? this.$finColors.accentGreen : this.$finColors.accentRed
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
